import { Component, OnInit } from '@angular/core';
import { LayoutQuery } from '../../../layout/state/layout.query';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss'],
  standalone: false,
})
export class SessionExpiredComponent implements OnInit {

  constructor(public layoutQuery: LayoutQuery) { }

  ngOnInit() {
  }

}
